<template lang="pug">
  div.chat
    div.chat_list(ref="box", id="box")
      div.chat_box(v-for="item in contentList", v-if="loadingHM==='loadedHM' && item.messageType !== '4'")
        div(v-if="item.showDef && !item.sessionType", class="chats2p")
          div.s2p_time {{formatDate()}}
          img.s2p_icon(:src="ntHead") 
          div.s2p_content
            p(class="toPage", @click='toPage()') {{$route.query.title}}
        div(v-if="item.sessionType==='s2p' && item.showDef", class="chats2p")
          div.s2p_time {{formatDate(item.date)}}
          img.s2p_icon(:src="ntHead") 
          div.s2p_content
            p(class="toPage", @click='toPage()') {{$route.query.title}}
          div.s2p_time(v-if="item.content!=='success'") {{formatDate(item.date)}}
          img.s2p_icon(:src="ntHead", v-if="item.content!=='success'") 
          div.s2p_content.sendLog_box(v-if="item.content!=='success'")
            p(v-if="item.messageType==='1'", v-html="item.content")
            img(v-if="item.messageType==='2'", :src="item.content", @click="showImg(item.content)")
            video(v-if="item.messageType==='3'", :src='item.content', controls="controls")
            //- p(v-if="item.messageType==='4'")
            //-   |{{$t('logRequest')}}
            p(v-if="item.messageType==='5'")
              |{{$t('netRequest')}}
          //- p(class="sendLog_btn", @click='sendLog(item)', v-if="sendBtn && item.content!=='success' && item.messageType==='4'") {{$t('sendLog')}}
          p(class="sendLog_btn", @click='sendNet(item)', v-if="sendNetBtn && item.content!=='success' && item.messageType==='5'") {{$t('sendNet')}}
        div(v-else-if='item.sessionType==="s2p" && !item.showDef', class="chats2p")
          div.s2p_time(v-if="item.content!=='success'") {{formatDate(item.date)}}
          img.s2p_icon(:src="ntHead", v-if="item.content!=='success'") 
          div.s2p_content.sendLog_box(v-if="item.content!=='success'")
            p(v-if="item.messageType==='1'", v-html="item.content")
            img(v-if="item.messageType==='2'", :src="item.content", @click="showImg(item.content)")
            video(v-if="item.messageType==='3'", :src='item.content', controls="controls")
            //- p(v-if="item.messageType==='4'")
            //-   |{{$t('logRequest')}}
            p(v-if="item.messageType==='5'")
              |{{$t('netRequest')}}
          //- p(class="sendLog_btn", @click='sendLog(item)', v-if="sendBtn && item.content!=='success' && item.messageType==='4'") {{$t('sendLog')}}
          p(class="sendLog_btn", @click='sendNet(item)', v-if="sendNetBtn && item.content!=='success' && item.messageType==='5'") {{$t('sendNet')}}
        div(v-else-if='item.messageType!=="4" && item.sessionType==="p2s" && !item.showDef', class="chatp2s")
          div.p2s_time {{formatDate(item.date)}}
          img.p2s_icon(:src="uHead")
          div.p2s_content
            p(v-if="item.messageType==='1'", v-html="item.content")
            img(v-if="item.messageType==='2'", :src="item.content", @click="showImg(item.content)")
            video(v-if="item.messageType==='3'", :src='item.content', controls="controls")
    div.chat_input(v-if="status > -1")
      van-field(v-model="submitBox", class="submit_box", type="textarea", rows="1")
      van-uploader(v-if='!submitBox', class="add_btn", :after-read="afterRead", accept="image/*, video/*")
        van-icon(name="add-o")
      van-button(v-if='submitBox', type="danger", class="submit_btn", @click="submitText") {{$t('send')}}
      //- VueEmoji(ref="emoji", @input="onInput", :value="myText")
    div.chat_assess(v-if="status === '-1'")
      div.assess_btn_box
        van-button(plain, class="assess_btn", @click="changeType(true)", :class="{'assess_active': assessType}")
          span(class="success") {{$t('solved')}}
        van-button(plain, class="assess_btn", @click="changeType(false)", :class="{'assess_active': !assessType}")
          span(class="cross") {{$t('notSolve')}}
      p.assess_tips {{$t('muchAssess')}}
      van-rate(class="assess_rate", v-model="rateValue", :icon='starImg', :void-icon='voidImg', :size="30", @change="rateChange")
      van-field(v-if="rateFlag", v-model="rateMsg", rows="3", type="textarea", :placeholder="$t('notAssess')")
      van-button(type="danger", class="assess_submit", round, @click="assessSubmit") {{$t('submit')}}
    div.chat_over(v-if="status === '-2' || status === '-4'")
      p {{$t('end')}}
    van-loading(v-if="showLoad===true", color="#E60012", vertical) {{$t('uploading')}}
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast, ImagePreview } from 'vant';

export default {
  name: 'Chat',
  data(){
    return{
      rateValue: 5,
      rateFlag: true,
      rateMsg: '',
      assessType: true,
      contentList: [],
      uploader: [],
      updata: [],
      submitBox: '',
      status: 0,
      starImg: require('@/assets/star.png'),
      voidImg: require('@/assets/void_star.png'),
      uHead: require('@/assets/head_icon.png'),
      ntHead: require('@/assets/head_icon1.png'),
      showLoad: false,
      sendBtn: true,
      sendNetBtn: true
    }
  },
  created(){
    this.status = this.$route.query.status
    // console.log(this.$route.query)
    if(this.$route.query.newMessage == '1'){
      this.updateMsgStatus(Qs.stringify({
        uid: this.uid,
        questionId: this.$route.query.id,
        accessToken: this.token,
        phoneModel: this.phoneModel,
        deviceId: this.deviceId
      }))
    }
    this.getHstQuMsgList(Qs.stringify({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      questionId: this.$route.query.id,
      phoneModel: this.phoneModel,
      pageNumber: 1
    }))
  },
  methods:{
    ...mapActions('faq', ['getHstQuMsgList', 'submitQuMsgText', 'submitQuMsgAttr', 'submitEvaluate', 'updateMsgStatus']),
    showImg(data){
      ImagePreview([data])
    },
    sendLog(params){
      this.sendBtn = false
      try {
        if(this.isNewUploadLog){
          typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.uploadLog('' + this.$route.query.id, '' + params.id, '' + (params.logStartTime || new Date().getTime() - 24 * 60 * 60 * 1000), '' + params.logEndTime || new Date().getTime()) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.uploadLog.postMessage({questionId: '' + this.$route.query.id, questionMessagesId: '' + params.id, startTime: ('' + params.logStartTime) || '', endTime: ('' + params.logEndTime) || ''}))
        } else {
          typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.uploadLog('' + this.$route.query.id, '' + params.id, '') || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.uploadLog.postMessage({questionId: '' + this.$route.query.id, questionMessagesId: '' + params.id, fileNum: ''}))
        }
      } catch (error) {
        console.log('不支持日志')
      }
    },
    sendNet(params){
      this.sendNetBtn = false
      try {
        typeof(ntAndroidWeb) !== 'undefined' && ntAndroidWeb.startCheckNet('' + this.$route.query.id, '' + params.id) || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.startCheckNet.postMessage({questionId: '' + this.$route.query.id, questionMessagesId: '' + params.id}))
      } catch (error) {
        console.log('不支持网络检测')
      }
    },
    changeType(flag){
      this.assessType = flag
    },
    toPage(){
      this.$router.push({
        path: '/faq/content',
        query: {
          id: this.$route.query.faqId,
          status: 0
        }
      })
    },
    assessSubmit(){
      this.submitEvaluate(Qs.stringify({
        uid: this.uid,
        questionId: this.$route.query.id,
        isSolve: this.assessType ? 1 : 2,
        isSatisfied: this.rateValue,
        extOpinion: this.rateMsg,
        accessToken: this.token,
        phoneModel: this.phoneModel,
        deviceId: this.deviceId
      }))
    },
    rateChange(value){
      if(value < 6){
        this.rateFlag = true
      } else {
        this.rateFlag = false
      }
    },
    submitText(){
      this.submitBox = this.submitBox.replaceAll('\n','</br>')
      // debugger
      this.submitQuMsgText({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        appId: this.appid,
        questionId: this.$route.query.id,
        sessionName: this.uname,
        phoneModel: this.phoneModel,
        content: this.submitBox
      })
      this.submitBox = '';
    },
    afterRead(files){
      if(this.showLoad){
        return false
      }
      // let items = files;
      // console.log(items)
      // for(let item in items){
      //     this.updata.push(this.dataURLtoFileFun(item.content, item.file.name, item.file.type));
      // }
      // console.log(this.updata);
      if(files.file.size > 104857600){
        Toast({
          message: this.$t('limit10M'),
          type: "fail"
        })
      } else {
        this.showLoad = true
        this.submitQuMsgAttr({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          appId: this.appid,
          questionId: this.$route.query.id,
          sessionName: this.uname,
          phoneModel: this.phoneModel,
          files: files.file
        })
      }
    },

    dataURLtoFileFun (dataurl, filename, type) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: type });
    },
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'appid', 'uname', 'phoneModel', 'isNewUploadLog']),
    ...mapGetters('faq', ['errmsg', 'FaqHstMsg', 'loadingHM', 'msgTextStatus', 'statusText', 'statusAttr', 'msgAttrStatus', 'faqEvalStatus', 'statusEval']),
    formatDate: (val, key = false) => {
      return (val = new Date().getTime(), key= false) => {
        // console.log(val)
        let payDate = new Date(parseInt(val));
        // console.log(payDate)
        if(key){
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds() + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);
        } else {
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds()
        }
      }
    }
  },
  mounted(){
    this.$watch('statusEval', val => {
      if(val === 'statedEval'){
        if(this.faqEvalStatus === 'success'){
          this.$router.push({
            path: '/faq/history'
          })
        }
      }
    })
    this.$watch('loadingHM', val => {
      if(val === 'loadedHM'){
        let num = 0
        this.contentList = this.FaqHstMsg.list.reverse().map(val => {
          if(val.messageType == '4' && val.content !== 'success'){
            this.sendLog(val)
          }
          if(val.sessionType === 's2p' && this.$route.query.faqStatus === '1'){
            if(num > 0){
              return val
            }
            const addArr = {showDef: true}
            num += 1
            return Object.assign(val, addArr)
          } else {
            return val
          }
        })
        if(num === 0 && this.$route.query.faqStatus === '1'){
          this.contentList.push({
            showDef: true
          })
        }
        // console.log(this.contentList[3].content)
        this.$nextTick(() => {
          var container = this.$el.querySelector('#box')
          document.documentElement.scrollTop = container.scrollHeight
          // console.log(container.scrollTop)
        })
      }
    })
    this.$watch('statusText', val => {
      if(val === 'statedText'){
        this.getHstQuMsgList(Qs.stringify({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          questionId: this.$route.query.id,
          phoneModel: this.phoneModel,
          pageNumber: 1
        }))
      }
    })
    this.$watch('statusAttr', val => {
      if(val === 'statedAttr'){
        this.showLoad = false
        this.getHstQuMsgList(Qs.stringify({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          questionId: this.$route.query.id,
          phoneModel: this.phoneModel,
          pageNumber: 1
        }))
      }
    })
  }
}
</script>
<style lang="scss">
.chat{
  margin-bottom: 80px;
  .toPage{
    color: #e60012;
    text-decoration: underline;
  }
  .van-loading{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.3);
  }
  .van-loading__spinner--circular{
    top: 50%
  }
  .van-loading__text{
    position: relative;
    top: 50%;
    color: #E60012
  }
  .assess_active{
    border-color: #ee0a24;
  }
  .van-field__control{
    // border: 1px solid #ebedf0;
    // min-height: 30px;
    border-radius: 10px;
    padding: 0 5px;
    line-height: 30px;
  }
  .assess_submit{
    width: 90%;
    margin-top: 10px;
    left: 5%;
    padding: 15px;
  }
  .assess_rate{
    left: 50%;
    transform: translateX(-50%);
    position: relative;
  }
  .chat_over{
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
  }
  .chat_assess{
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: #fff;
    padding-top: 20px;
    padding-bottom: 20px;
    .assess_tips{
      text-align: center;
    }
    .assess_btn_box{
      width: 100%;
      display: flex;
      justify-content: space-around;
      .assess_btn{
        width: 40%;
        line-height: 40px;
        padding: 20px 0;
        border-radius: 10px;
        .success{
          background: url(../../assets/success.png) 0 0 no-repeat;
          background-size: auto 100%;
          padding-left: 25px;
        }
        .cross{
          background: url(../../assets/cross.png) 0 0 no-repeat;
          background-size: auto 100%;
          padding-left: 25px;
        }
      }
    }
  }
  #box{
    position: relative;
    overflow: scroll;
  }
  .chat_box{
    margin: 20px;
  }
  .p2s_time,
  .s2p_time{
    text-align: center;
    margin: 0;
    padding: 0;
    font-size: 10px;
    color: #969799
  }
  .s2p_icon{
    margin: 10px 0;
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background-color: #969799;
    position: relative;
  }
  .p2s_icon{
    margin: 10px 0;
    margin-left: calc(100% - 30px);
    width: 30px;
    height: 30px;
    border-radius: 15px;
    background-color: #969799;
    position: relative;
  }
  .sendLog_btn{
    font-size: 14px;
    margin-left: 40px;
    margin-top: -10px;
    max-width: 60%;
    margin-bottom: 10px;
    border-radius: 5px;
    box-shadow: 0px 5px 5px 2px #ebebeb;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    background-color: #fff;
    padding: 8px;
    border-top: 1px solid #ebebeb;
    text-align: center;
    background-color: #E60012;
    color: #fff;
  }
  .s2p_content{
    font-size: 14px;
    margin-left: 40px;
    margin-top: -35px;
    max-width: 60%;
    margin-bottom: 10px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 2px #ebebeb;
    background-color: #fff;
    padding: 8px;
    &.sendLog_box{
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
    p{
      margin: 0;
      display: block;
      word-wrap: break-word;
      word-break: normal;
    }
    img{
      width: 100%;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    video{
      width: 100%;
    }
  }
  .p2s_content{
    font-size: 14px;
    margin-left: calc(10% + 40px);
    margin-top: -35px;
    max-width: 60%;
    margin-bottom: 10px;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 2px #ebebeb;
    background-color: #ef8981;
    padding: 8px;
    p{
      margin: 0;
      display: block;
      word-wrap: break-word;
      word-break: normal;
    }
    img{
      width: 100%;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    video{
      width: 100%;
    }
  }
  .chat_input{
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: #fff;
    margin-bottom: -30px;
    .submit_box{
      width: 70%;
      background-color: #f7f7f7;
      margin: 10px 0;
      line-height: 28px;
      margin-left: 20px;
    }
    .add_btn{
      position: relative;
      top: -45px;
      padding: 0 20px;
      line-height: 28px;
      height: 28px;
      font-size: 20px;
      margin-left: calc(100% - 80px);
    }
    .submit_btn{
      position: relative;
      top: -45px;
      padding: 0 20px;
      line-height: 28px;
      height: 28px;
      font-size: 12px;
      margin-left: calc(100% - 80px);
    }
  }
}
</style>